<template>
  <div>
      <HeaderIndex></HeaderIndex>
      <div class="w1100">
       	<div class="marginT10">
        	<div class="is-postion fb">
              <div class="is-posbg">您当前的位置： <a href="/">网站首页</a>
            	</div>
          </div>
          <div style="border:1px solid #ccc; border-top:none; padding-top:15px;line-height:26px; font-size:12px;text-align:center;padding:20px 0px 20px 0px;" v-if="this.contentData && this.contentData.deleted">内容不存在</div>
          <div style="border:1px solid #ccc; border-top:none; padding-top:15px;">
              <div class="border_l border_r border_b border_ECEAEB">
                  <div id="BodyLabel" style="padding:20px 40px 40px 40px;line-height:28px; font-size:14px;overflow:hidden;">
                    <p>您好！如有情况需要反映，请向潜山市委组织部干部监督科口头、书面反映。</p>
                    <p>电 话：12380-3   邮 箱：qssgbjdk@163.com</p>
                    <p>举报需知:</p>
                    <p>一、主要受理反映潜山市下辖各乡镇及市直单位违反《党政领导干部选拔任用工作条例》选人用人问题的举报；干部考察、任前公示、试用期间问题的举报；领导班子、领导干部的其他问题。</p>
                    <p>二、反映“举报内容”时,要写清楚问题发生的时间、地点、情节、后果等，字数限定在800字以内。</p>
                    <p>三、举报人应实事求是地反映问题。对利用举报捏造事实,进行诬告陷害的，依照有关规定严肃处理；构成犯罪的，移交司法机关处理。</p>
                    <p>四、提倡实名举报。进行实名举报的，请注明举报人姓名、联系电话等。</p>
                    <p>五、为保障举报人的合法权益，提高网上举报的运行效益，请不要重复举报和发送垃圾信件。</p>
                  </div>
              </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <FooterIndex name="footerIndex"></FooterIndex>
  </div>
</template>


<script>

import FooterIndex from './FooterIndex'
import HeaderIndex from './HeaderIndex'
import request from '@/common/request'
import  '../assets/css/css.css'

export default {
  name: 'DetailIndex',
  data () {
    return {
    }
  },
  components: {
      FooterIndex,HeaderIndex
  },
  mounted() {
  },
  watch: {
  },
  methods: {
  }
}
</script>

<style scoped>
.titleInfo{ width:100%; clear:both; height:30px; line-height:30px; text-align:center; font-size:12px; border-bottom:1px dashed #cccccc; color:#666666; }
</style>



// WEBPACK FOOTER //
// src/components/Report.vue